<template>
    <div>
        <div class="maxbox">
            <div>
                <div class="top">
                    <p>矿机</p>
                </div>
                <div class="main"
                    style="padding-top: 50px;display: flex;justify-content: center;align-items: center;flex-direction: column;height: 800px;">
                    <!-- 动态变化的计数器显示 -->
                    <h3>{{ displayNumber }}</h3>
                    <h3>{{ displayRate }}/秒</h3>
                    <!-- 修改点：添加@click事件和cursor样式，实现点击跳转 -->
                    <img 
                        src="@/assets/images/kj2.png" 
                        alt="" 
                        style="width: 200px;height: 200px;cursor: pointer;"
                        @click="goToClaimFC"
                    >
                    <div class="content" style="left: 0;top:240px">
                        <img src="@/assets/images/f1-1.png" alt="" srcset="">
                        <div style="font-size:10px">矿机{{ 1 }}台</div>
                        <svg width="80" height="50" style="position: absolute;left:100%;top: 0;">
                            <polyline points="0,20 30,20 60,40" stroke="blue" stroke-width="1" fill="none" />
                            <circle cx="60" cy="40" r="5" stroke="blue" stroke-width="1" fill="white" />
                        </svg>
                    </div>
                    <div class="content" style="left: 0;top:350px">
                        <img src="@/assets/images/f2-1.png" alt="" srcset="">
                        <div style="font-size:10px">运行中{{ 1 }}台</div>
                        <svg width="80" height="50" style="position: absolute;left:100%;top: 0;">
                            <polyline points="0,20 20,20 " stroke="blue" stroke-width="1" fill="none" />
                            <circle cx="20" cy="20" r="5" stroke="blue" stroke-width="1" fill="white" />
                        </svg>
                    </div>
                    <div class="content" style="right: 0;top:240px">
                        <img src="@/assets/images/f3-1.png" alt="" srcset="">
                        <div style="font-size:10px">矿机算力{{ 230  }}KH/s</div>
                        <svg width="50" height="90" style="position: absolute;right:100%;top: 0;">
                            <polyline points="50,20 30,20 20,70" stroke="blue" stroke-width="1" fill="none" />
                            <circle cx="20" cy="70" r="5" stroke="blue" stroke-width="1" fill="white" />
                        </svg>
                    </div>
                    <br><br>
                    
                    <!-- 启动矿机按钮 -->
                    <div style="color:black;line-height:1.5;text-align:center;margin-top:20px">启动矿机</div>
                    <div class="loader">
                        <div style="display: flex;justify-content:center;align-items:center;position:relative">
                            <svg width="80" height="80" viewBox="0 0 100 100" :class="{ 'svgroate': isStarted }">
                                <defs>
                                    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%">
                                        <stop offset="0%" stop-color="white" />
                                        <stop offset="50%" stop-color="lightblue" />
                                        <stop offset="100%" stop-color="white" />
                                    </linearGradient>
                                </defs>
                                <circle cx="50" cy="50" r="45" stroke="url(#gradient)" stroke-width="10" fill="transparent" />
                            </svg>
                            <svg width="40" height="40" class="arrow" @click="startMachine">
                                <polyline points="0,20 40,20 20,0" stroke="white" stroke-width="4" fill="none" />
                                <polyline points="40,20 20,40" stroke="white" stroke-width="4" fill="none" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'kuangji',
    data() {
        return {
            totalMachines: 0,
            runningMachines: 0,
            expiredMachines: 0,
            displayNumber: 0,
            displayRate: 0,
            isStarted: false,
            counterInterval: null
        };
    },
    mounted() {
        this.checkMachineStatus();
    },
    methods: {
        // 新增方法：跳转到claim-fc.vue页面
        goToClaimFC() {
            this.$router.push('/claim-fc');
        },
        startCounter() {
            this.counterInterval = setInterval(() => {
                this.displayNumber = (parseFloat(this.displayNumber) + Math.random()).toFixed(5);
                this.displayRate = (Math.random() * 0.00001).toFixed(10);
            }, 1000);
        },
        startMachine() {
            if (!this.isStarted) {
                this.isStarted = true;
                localStorage.setItem('machineStarted', 'true');
                this.startCounter();
            }
        },
        checkMachineStatus() {
            const machineStarted = localStorage.getItem('machineStarted');
            if (machineStarted === 'true') {
                this.isStarted = true;
                this.startCounter();
            }
        }
    }
}
</script>

<style scoped>
.button {
    background-color: #429dff;
    color: #fff;
    border: 0;
    width: 74px;
    height: 28px;
    border-radius: 4px;
    margin-top: 20px;
}

.content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
}

.content>img {
    width: 40px;
    height: 40px;
}

.svgroate {
    animation: rotate 2s linear infinite;
}

.arrow {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    /* 新增：箭头闪烁动画 */
    animation: blink 1.5s ease-in-out infinite;
}

/* 新增：闪烁动画关键帧 */
@keyframes blink {
    0%, 100% {
        opacity: 1;
        filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.8));
    }
    50% {
        opacity: 0.4;
        filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.4));
    }
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
